document.addEventListener("DOMContentLoaded", () => {
  const toast = document.querySelector("[data-toast]");
  let toastTimer;
  window.nsToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove("is-visible"), 2600);
  };

  document.querySelectorAll("[data-qty]").forEach((wrap) => {
    const input = wrap.querySelector("input");
    wrap.querySelectorAll("[data-qty-btn]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const delta = Number(btn.dataset.qtyBtn || 0);
        const next = Math.max(1, Number(input.value || 1) + delta);
        input.value = next;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  document.querySelectorAll("[data-menu-toggle]").forEach((button) => {
    button.addEventListener("click", () => {
      const nav = document.querySelector("[data-mobile-nav]");
      if (!nav) return;
      nav.hidden = !nav.hidden;
    });
  });

  document.querySelectorAll("[data-add-to-cart]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const button = form.querySelector("button[type=submit]");
      const oldText = button ? button.textContent : "";
      if (button) { button.disabled = true; button.textContent = "Adding…"; }

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8", "Accept": "application/json" },
          body: new URLSearchParams(new FormData(form))
        });
        if (!response.ok) throw new Error("Cart error");
        const item = await response.json();
        nsToast(`${item.product_title || "Item"} added to your cart.`);
        setTimeout(() => window.location.href = "/cart", 650);
      } catch (e) {
        nsToast("Sorry, we couldn't add that item. Please try again.");
      } finally {
        if (button) { button.disabled = false; button.textContent = oldText; }
      }
    });
  });

  document.querySelectorAll("[data-thumb]").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const main = document.querySelector("[data-main-image]");
      if (!main) return;
      main.src = thumb.dataset.thumb;
    });
  });
});